export const HorizontalRule = 'hr';
